import React, { Component } from 'react';
import {reduxForm, Field} from 'redux-form';
import {FormattedHTMLMessage} from 'react-intl';
import withAuthControl from '../auth/Auth.js';
import SaveStepButton from './SaveStepButton';
import TopScrolleable from './TopScrolleable.js';
import generateValidator from './Validations/generateValidator';
import Section from './Section.js';
import CustomSpinner from './CustomSpinner';
import CustomAlert from './CustomAlert.js';
import RenderField from './RenderField';

class LoanReasonForm extends Component {

    constructor(props) {
        super(props);
        this.state = { loan_reason: null };
    }

    render() {
        const { handleSubmit, submitting, error } = this.props;

        return (
            <Section className="intro_form">
                <div className="row">
                    <div className="pd-content-left col-md-5 col-lg-5 text-center">
                        <img alt="Logo" className="center-block intro_logo" src={require(`../assets/${process.env.PAGE}/img/logo-h-blanco.png`)}/>
                        <FormattedHTMLMessage id="app.step_loan_reason" description="Loan Reason"/>
                        <div className="show-desktop">
                            <SaveStepButton/>
                        </div>
                    </div>
                    <div className="pd-content-right short-content col-sm-12 col-md-7 col-lg-7">
                        <form onSubmit={handleSubmit(this.props.saveLoanReason)} className="pvc-form">
                            {this.props.isLoading && <CustomSpinner message='Estamos analizando tu solicitud. Por favor esperá...' /> }
                            {error && <CustomAlert bsStyle="danger" message={error}/>}
                            <div className="col-md-12 col-lg-12">
                                <div className="form-group">
                                    <Field className="form-control" name="loan_reason" autoComplete="off" component={RenderField} type="textarea" label="Describí tu actividad, los productos o servicios que ofrecés y el volumen de venta del último año." maxChars={500} showSuccess={true} />
                                </div>
                            </div>
                            <div className="col-md-12 col-lg-12">
                                <div className="form-group">
                                    <Field className="form-control" name="loan_activity" autoComplete="off" component={RenderField} type="textarea" label="Describí lo que vas a financiar con este crédito y el objetivo de tu inversión, detallando los bienes o servicios que vas a producir. Agregá el monto del aporte propio y a qué vas a destinarlo." rows={4} maxChars={500} showSuccess={true} />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12 text-center">
                                    <button type="submit" className="btn btn-warning btn-lg pd-button pd-form" disabled={submitting}>Continuar</button>
                                </div>
                            </div>
                        </form>
                        <div className="show-mobile">
                            <SaveStepButton/>
                        </div>
                    </div>
                </div>
            </Section>
        );
    }
}

LoanReasonForm.contextTypes = {
    intl: React.PropTypes.object.isRequired
}

let validate = generateValidator([{name: 'loan_reason', required: true},{name: 'loan_activity', required: true}]);

LoanReasonForm = TopScrolleable(LoanReasonForm);

LoanReasonForm = reduxForm({
    form: 'LoanReason', // a unique name for this form
    validate
})(LoanReasonForm);

LoanReasonForm = withAuthControl(LoanReasonForm);

export default LoanReasonForm;


/** WEBPACK FOOTER **
 ** ./src/components/LoanReasonForm.js
 **/